import { useState, useEffect } from 'react';
import { useDispatchHookEvent } from '@rammetec/core';
import { useAuthService } from '../context/AuthServiceContext.js';
/**
 * Hook that subscribes to authentication state changes and exposes the current auth user.
 * Returns a tuple: [user, isLoading, error].
 */
export const useAuth = () => {
    const authService = useAuthService();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error] = useState(undefined);
    useEffect(() => {
        const unsubscribe = authService.onAuthStateChanged((user) => {
            setUser(user);
            setLoading(false);
        });
        return () => unsubscribe();
    }, [authService]);
    useDispatchHookEvent('useAuth', { userId: user?.userId, loading, error });
    return [user, loading, error];
};
//# sourceMappingURL=useAuth.js.map